var _rect, _ellipse, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Restaurant carryout and trash bags") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    fill: "#f5efe4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 440,
    rx: 250,
    ry: 28,
    fill: "#162d45",
    opacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170 150h260l-22 275H192z",
    fill: "#c49356",
    stroke: "#162d45",
    strokeWidth: 14,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M238 170v-40c0-65 125-65 125 0v40",
    fill: "none",
    stroke: "#162d45",
    strokeWidth: 14
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M450 205h170l48 220H430z",
    fill: "#26394d",
    stroke: "#162d45",
    strokeWidth: 14,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M485 207c-18-60 105-60 100 0",
    fill: "none",
    stroke: "#162d45",
    strokeWidth: 14
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245 270h110",
    stroke: "#fff",
    strokeWidth: 14,
    strokeLinecap: "round",
    opacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBags);
export default __webpack_public_path__ + "static/media/bags.877370e1a63bc44daad830a059f17d82.svg";
export { ForwardRef as ReactComponent };